'use client';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ApiProvider } from '@reduxjs/toolkit/query/react';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes/routes';
import { I18nextProvider } from 'react-i18next';
import i18n from './utils/i18n';
import { store } from '@redux/store';
import { ebookApi } from '@services/api';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorBoundaryFallback } from '@features/ErrorBoundary/ErrorBoundaryFallback';
import { APIProvider as MapProvider } from '@vis.gl/react-google-maps';

const element = document.querySelector('#root');
if (element) {
  const root = createRoot(element);
  root.render(
    <I18nextProvider i18n={i18n}>
      <ApiProvider api={ebookApi}>
        <MapProvider apiKey={process.env.GOOGLE_MAPS_API_KEY}>
          <Provider store={store}>
            <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
              <RouterProvider router={router} />
            </ErrorBoundary>
          </Provider>
        </MapProvider>
      </ApiProvider>
    </I18nextProvider>
  );
}
